// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'
import device from 'vue-device-detector'
import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
Vue.use(wysiwyg)
Vue.use(device)

Vue.config.productionTip = false

import './assets/scss/style.scss'

Vue.filter('moneyFormatter', val => {
  return Intl.NumberFormat('tr', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(val)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js